import {
  DataGrid,
  GridColDef,
  GridPaginationModel,
  GridRenderCellParams,
  GridRowClassNameParams,
  GridSortModel
} from "@mui/x-data-grid";
import React, {useState} from "react";
import {GridSortDirection, GridSortItem} from "@mui/x-data-grid/models/gridSortModel";
import {SxProps} from "@mui/material";
import {Theme} from "@emotion/react";
import './AmsDataGrid.css';
import {GridInitialStateCommunity} from "@mui/x-data-grid/models/gridStateCommunity";

export const DEFAULT_PAGE_SIZE = 10;

interface AmsDataGridProps {
  style?: SxProps<Theme> | undefined,
  className?: string,
  rows?: any[],
  rowCount?: number,
  rowIdFunction?: (row: any) => string | number,
  columnModel?: AmsDataGridColumnDef[],
  loadingFlag?: boolean,
  paginationChangeFunction?: (pageModel: AmsDataGridPageModel) => void,
  sortChangeFunction?: (sortModel: AmsDataGridSortItem[]) => void
  initialSort?: AmsDataGridSortItem[],
  hideFooter?: boolean,
  disableSorting?: boolean,
  rowClassNameFunction?: (params: AmsGridRowClassNameParams) => string,
  initialState?: GridInitialStateCommunity | undefined
}

export type AmsDataGridColumnDef = GridColDef;
export type AmsDataGridPageModel = GridPaginationModel;
export type AmsDataGridCellRenderParams = GridRenderCellParams;
export type AmsGridRowClassNameParams = GridRowClassNameParams;

export interface AmsDataGridSortItem {
  field: string,
  direction: string
}

export function AmsDataGrid({
                              style,
                              className,
                              rows,
                              rowIdFunction,
                              rowCount,
                              columnModel,
                              loadingFlag,
                              paginationChangeFunction,
                              sortChangeFunction,
                              initialSort,
                              hideFooter,
                              disableSorting,
                              rowClassNameFunction,
                              initialState
                            }: AmsDataGridProps) {
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE
  });
  let initialSortModel: GridSortItem[] = [];


  if (initialSort) {
    initialSortModel = initialSort?.map(i => {
      return {
        field: i.field,
        sort: i.direction === "asc" ? "asc" as GridSortDirection : "desc" as GridSortDirection
      } as GridSortItem
    });
  }
  const [sortModel, setSortModel] = useState<GridSortModel>(initialSortModel);

  const handlePaginationChange = (model: GridPaginationModel) => {
    setPaginationModel(model);
    if (paginationChangeFunction) {
      paginationChangeFunction({page: model.page, pageSize: model.pageSize});
    }
  };

  const handleSortChange = (model: GridSortModel) => {
    setSortModel(model)
    if (sortChangeFunction) {
      sortChangeFunction(model.map(i => {
        return {field: i.field, direction: `${i.sort}`}
      }));
    }
  }

  return (
      <DataGrid
          sx={style}
          className={className}
          rows={rows}
          getRowId={rowIdFunction}
          columns={columnModel ? columnModel as GridColDef[] : []}
          rowCount={rowCount}
          paginationModel={paginationModel}
          onPaginationModelChange={handlePaginationChange}
          pageSizeOptions={[5, 10, 20]}
          paginationMode="server"
          sortingMode="server"
          filterMode="server"
          sortModel={sortModel}
          hideFooter={hideFooter}
          onSortModelChange={handleSortChange}
          disableColumnSorting={disableSorting}
          getRowClassName={rowClassNameFunction}
          loading={loadingFlag}
          initialState={initialState}
      />
  )
}
